const clickedModalData = [
    {
        id: 1,
        img: "https://img.icons8.com/color/2x/angularjs.png",
        title: 'Angular JS',
        desc: 'AngularJS is a structural JavaScript framework for developing single-page applications. It was maintained mainly by Google'
    },
    {
        id: 2,
        img: "https://img.icons8.com/color/2x/react-native.png",
        title: 'React JS',
        desc: 'React is a declarative, efficient, and flexible JavaScript library for building user interfaces based on UI components.'
    },
    {
        id: 3,
        img: "https://img.icons8.com/color/2x/vue-js.png",
        title: 'Vue JS',
        desc: 'VueJS is a progressive JavaScript framework for building user interfaces and single-page applications.'
    },
];

export default clickedModalData;